import {observable} from 'mobx';
import {createInstance} from 'utils';

import {CtLocaleKey} from './ct-locale-key';
import {CtLocaleContent} from './ct-locale-content';

export class CtLocale extends CtLocaleKey {
    @observable id!: number;

    @observable initialContent: string = '';

    @observable motherContent?: CtLocaleContent;

    @observable targetContent?: CtLocaleContent;

    constructor(translation?: CtLocale) {
        super(translation);
        if (translation) {
            this.id = translation.id;
            this.motherContent = createInstance(CtLocaleContent, translation.motherContent);
            this.targetContent = createInstance(CtLocaleContent, translation.targetContent);
            if (this.targetContent) {
                this.initialContent = this.targetContent.contentEdited;
            }
        }
    }
}